var _style, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "google_svg__Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 411.9 153.9"
    },
    viewBox: "0 0 411.9 153.9"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".google_svg__st0{fill:#0085f7}.google_svg__st1{fill:#ff4131}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.1 58.9H59.3v13.8h34.9C90 88.1 76 99.4 59.3 99.4c-20 0-36.2-16.2-36.2-36.2S39.3 27 59.3 27c9.1 0 17.8 3.4 24.5 9.5l9.8-9.8C84.3 18 72 13.2 59.3 13.2c-27.6 0-50 22.4-50 50s22.4 50 50 50 50-22.4 50-50c0-1.5-.1-2.9-.2-4.3z",
    className: "google_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M146.4 48.6c-17.6 0-32 14.4-32 32.2s14.3 32.2 32 32.2 32-14.4 32-32.2-14.3-32.2-32-32.2zm0 51.5c-9.7 0-17.5-8.5-17.5-18.9s7.8-18.9 17.5-18.9 17.5 8.5 17.5 18.9-7.8 18.9-17.5 18.9z",
    className: "google_svg__st1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M215.6 48.6c-17.6 0-32 14.4-32 32.2s14.3 32.2 32 32.2 32-14.4 32-32.2-14.4-32.2-32-32.2zm0 51.5c-9.7 0-17.5-8.5-17.5-18.9s7.8-18.9 17.5-18.9 17.5 8.5 17.5 18.9-7.9 18.9-17.5 18.9z",
    style: {
      fill: "#ffbc00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.2 13.2H331v101h-13.8z",
    style: {
      fill: "#00a94b"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M385.7 89c-4.6 9.3-15.8 13.2-25.2 8.6-2.6-1.3-4.8-3.1-6.6-5.4l46.9-18.3-.7-2.4c-.3-.9-.6-1.8-.9-2.6-6.6-16.8-25.5-25-42.2-18.5s-25 25.5-18.5 42.2c6.6 16.8 25.5 25 42.2 18.5 7.7-3 14-8.9 17.6-16.4l1.2-2.6-12.6-5.5-1.2 2.4zm-4.3-22.3L350.1 79c1-10.4 10.1-18 20.5-17 4 .4 7.8 2 10.8 4.7z",
    className: "google_svg__st1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M298.1 48.6v5.7c-4.7-3.6-10.3-5.7-16.4-5.7-16 0-29 14.4-29 32.2s13 32.2 29 32.2c6.1 0 11.8-2.1 16.4-5.7v6.9c0 4-2.9 15-15.9 15s-16.7-11.6-16.7-11.6l-12.5 5.8s4.7 18.4 30.4 18.4c13.9 0 21.1-8.1 24.8-15.5 2.5-5 3.7-10.6 3.7-16.2V48.6h-13.8zm-16.4 51.5c-8.8 0-15.8-8.5-15.8-18.9s7.1-18.9 15.8-18.9 15.8 8.5 15.8 18.9-7 18.9-15.8 18.9z",
    className: "google_svg__st0"
  })));
};
export default SvgGoogle;